import React from "react";
import { Typography } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";
import BorderedIconWrapper from "@/components/common/BorderIconWrapper";
import PlusIcon from '@/assets/svg/plus.svg';

interface CardItemComponentProps {
  id: string;
  title: string;
  subtitle: string;
  icon: { light: string; dark: string };
  isAdded: boolean;
  onAdd?: (id: string) => void;
  onRemove?: (id: string) => void;
}

const CardItemComponent: React.FC<CardItemComponentProps> = ({
  id,
  title,
  subtitle,
  icon,
  isAdded,
  onAdd,
  onRemove,
}) => {
  return (
    <div className='flex items-start gap-3 w-full min-h-[103px] py-4 border-b border-grey-200 dark:border-grey-700'>
      {/* Icon */}
      <BorderedIconWrapper>
        <div className='w-5 h-5'>
          <img src={icon.light} alt={title} className='w-5 h-5 block dark:hidden' />
          <img src={icon.dark} alt={title} className='w-5 h-5 hidden dark:block' />
        </div>
      </BorderedIconWrapper>

      {/* Title + Subtitle */}
      <div className='flex-1 min-w-0 flex flex-col gap-[10px]'>
        <Typography
          variant='semibold-14'
          className='text-grey-800 dark:text-white'>
          {title}
        </Typography>
        <Typography
          variant='regular-14'
          className='text-grey-600 dark:text-grey-400'>
          {subtitle}
        </Typography>
      </div>

      {/* Action button */}
      <div className='flex-shrink-0 self-center'>
        {isAdded ? (
          <Button
            variant='outline2'
            size='md'
            className='rounded-lg'
            onClick={() => onRemove?.(id)}
            label="Remove"
          />
        ) : (
          <Button
            variant='contained1'
            size='md'
            className='rounded-lg'
            onClick={() => onAdd?.(id)}
            label="Add"
            startIcon={<img src={PlusIcon} alt="plus" className="w-4 h-4" />}
          />
        )}
      </div>
    </div>
  );
};

export default CardItemComponent;
